import axios from 'axios';

const getConstratacoesList = params => axios.get('/contratacoes-fretes/list', {
  params,
});

export default {
  getConstratacoesList,
};
